export default __webpack_public_path__ + "static/image2-b00401cf1a667c9f38478a5adeca4844.gif";